export default function (dataUrl, maxWidth = 1280) {
  return new Promise((resolve) => {
    const img = new Image()
    img.src = dataUrl
    img.onload = function () {
      const canvas = document.createElement('canvas')
      const ratio = maxWidth / img.width
      const width = img.width > maxWidth ? maxWidth : img.width
      const height = img.width > maxWidth ? img.height * ratio : img.height

      canvas.width = width
      canvas.height = height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, width, height)
      resolve(canvas.toDataURL('image/webp', 1.0))
    }
  })
}
